import { DatePicker, Row, Select } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { setDrawerFilter, setTableData } from '../store/finalReports.slice'


const UserReportDrawerDateFilter = () => {
    const { reportDrawerFilterData } = useSelector((state) => state.finalReportsSlice)
    const { RangePicker } = DatePicker
    const { Option } = Select
    const dispatch = useDispatch()

    const disableFutureDates = (current) =>
        current && current > dayjs().endOf('day')

    const handleDateTypeChange = (type) => {
        const today = dayjs()
        let start = null,
            end = null

        switch (type) {
            case 'day':
                start = today.startOf('day').valueOf()
                end = today.endOf('day').valueOf()
                break
            case 'week':
                start = today.startOf('week').startOf('day').valueOf()
                end = today.endOf('week').endOf('day').valueOf()
                break
            case 'month':
                start = today.startOf('month').startOf('day').valueOf()
                end = today.endOf('month').endOf('day').valueOf()
                break
            default:
                start = null
                end = null
        }

        const dataSet = {
            ...reportDrawerFilterData,
            page: 1,
            start,
            end,
        }

        dispatch(
            setDrawerFilter({
                ...dataSet,
                dateType: type,
            })
        )
        //  dispatch(
        //      getAllUserReportList({
        //          ...dataSet,
        //      })
        //  )
    }

    const handleDateChange = (val) => {
        if (!val) return

        let start = null,
            end = null

        if (reportDrawerFilterData.dateType === 'custom') {
            start = val[0].startOf('day').valueOf()
            end = val[1].endOf('day').valueOf()
        } else {
            const date = dayjs(val)
            if (reportDrawerFilterData.dateType === 'day') {
                start = date.startOf('day').valueOf()
                end = date.endOf('day').valueOf()
            } else if (reportDrawerFilterData.dateType === 'week') {
                start = date.startOf('week').startOf('day').valueOf()
                end = date.endOf('week').endOf('day').valueOf()
            } else if (reportDrawerFilterData.dateType === 'month') {
                start = date.startOf('month').startOf('day').valueOf()
                end = date.endOf('month').endOf('day').valueOf()
            }
        }

        const dataSet = {
            ...reportDrawerFilterData,
            page: 1,
            start,
            end,
        }
        dispatch(
            setDrawerFilter({
                ...dataSet,
            })
        )
        //  dispatch(
        //      getAllUserReportList({
        //          ...dataSet,
        //      })
        //  )
    }

    useEffect(() => {
        // set initial value when component mounts
        handleDateTypeChange(reportDrawerFilterData.dateType || 'day')
    }, [])
    return (
        <Row
            align="middle"
            justify="end"
            style={{ columnGap: '20px', width: '100%', flexWrap: 'nowrap' }}
        >
            <div className="reportsDate" >
                {reportDrawerFilterData.dateType === 'custom' ? (
                    <RangePicker
                        style={{ width: "100%" }}
                        onChange={handleDateChange}
                        format="DD/MM/YYYY"
                        disabledDate={disableFutureDates}
                        value={[
                            reportDrawerFilterData.start ? dayjs(reportDrawerFilterData.start) : null,
                            reportDrawerFilterData.end ? dayjs(reportDrawerFilterData.end) : null,
                        ]}
                    />
                ) : (
                    <DatePicker
                        picker={reportDrawerFilterData.dateType}
                        value={[
                            reportDrawerFilterData.start ? dayjs(reportDrawerFilterData.start) : null,
                            reportDrawerFilterData.end ? dayjs(reportDrawerFilterData.end) : null,
                        ]}
                        style={{ width: "100%" }}
                        onChange={handleDateChange}
                        format={
                            reportDrawerFilterData.dateType === 'day'
                                ? 'DD/MM/YYYY'
                                : reportDrawerFilterData.dateType === 'week'
                                    ? 'DD/MM'
                                    : 'MM/YYYY'
                        }
                        disabledDate={disableFutureDates}
                    />
                )}
            </div>

            <Select
                placeholder="Filter"
                value={reportDrawerFilterData.dateType}
                onChange={handleDateTypeChange}
                style={{ width: 120 }}
            >
                <Option value="day">Day</Option>
                <Option value="week">Week</Option>
                <Option value="month">Month</Option>
                <Option value="custom">Custom</Option>
            </Select>
        </Row>
    )
}

export default UserReportDrawerDateFilter
